module.exports = __webpack_public_path__ + "img/background-scan.f5849fc4.svg";